import { DateAdapter, DateUnit } from "@/infrastructure/adapters/dayJs";
export class DateService {
  constructor(private readonly dateAdapter: DateAdapter) {}

  getCurrentDate(): Date {
    return this.dateAdapter.getCurrentDate();
  }

  format(date: string, format: string): string {
    return this.dateAdapter.format(date, format);
  }

  add(date: string, amount: number, unit: DateUnit): Date {
    return this.dateAdapter.add(date, amount, unit);
  }

  subtract(date: string, amount: number, unit: DateUnit): Date {
    return this.dateAdapter.subtract(date, amount, unit);
  }

  isBefore(date1: string, date2: string): boolean {
    return this.dateAdapter.isBefore(date1, date2);
  }

  isAfter(date1: string, date2: string): boolean {
    return this.dateAdapter.isAfter(date1, date2);
  }

  isValid(date: string): boolean {
    return this.dateAdapter.isValid(date);
  }

  diff(date1: string, date2: string, unit: DateUnit): number {
    return this.dateAdapter.diff(date1, date2, unit);
  }

  startOfMonth(date: string): Date {
    return this.dateAdapter.startOfMonth(date);
  }

  timeUntil(date: string): string {
    return this.dateAdapter.timeUntil(date);
  }
}
